import React from 'react';
import classNames from 'classnames';
import {Outlet} from 'react-router-dom';

const Login = () => {
  return (
    <div className={classNames('login')}>
      <Outlet/>
    </div>
  )
}

export default Login